import {
  Card,
  CardBody,
  CardFooter,
  CardHeader,
} from "../../../components/card/card";

import React, { useState, useEffect } from "react";

import CategoryList from "./list";
const pages = ["Work Order", "Asset", "Part", "Vendor", "Customer"];
function CategoryConfiguration() {
  return (
    <div>
      <div className="d-flex align-items-center mb-3">
        <div>
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">Setup</a>
            </li>
            <li className="breadcrumb-item active">Category</li>
          </ol>
          <h1 className="page-header mb-0">Category / Type</h1>
        </div>
      </div>

      <div className="row gx-4">
        <div className="col-lg-12">
          <Card className="mb-4">
            <CardHeader>Update Category / Type</CardHeader>
            <CardBody>
              <ul className="nav nav-tabs pt-3 ps-4 pe-4">
                {pages.map((item, index) => {
                  return (
                    <li className="nav-item me-1" key={index}>
                      <a
                        href={"#tab" + index}
                        className={index == 0 ? "nav-link active" : "nav-link"}
                        data-bs-toggle="tab"
                      >
                        {item}
                      </a>
                    </li>
                  );
                })}
              </ul>
              <div className="tab-content pt-3">
                {pages.map((item, index) => {
                  return (
                    <div
                      className={
                        index == 0
                          ? "tab-pane fade show active"
                          : "tab-pane fade show"
                      }
                      id={"tab" + index}
                    >
                      <CategoryList type={item} />
                    </div>
                  );
                })}
              </div>
            </CardBody>
          </Card>
        </div>
      </div>
    </div>
  );
}
export default CategoryConfiguration;
